import React, { PureComponent } from 'react';
import { AtcSectorOpening, ExtendedMonitoredTv, MonitoredMcdmMeasure, MonitoredMeasure } from '../../../../model/SOL49';
import { Flex } from '../../../common/Flex';
import { FlowSectionHeader } from '../flows/FlowSectionHeader';
import { Range, TimeScale } from '../../../../common/graph/Scale';
import AutoSizer from 'react-virtualized-auto-sizer';
import { AxisOrientation, TimeAxis, TimeLabelFormat } from '../../../../common/graph/Axis';
import { CountType, FlightId, TimePeriod } from '../../../../model/CORE';
import { SectorOpening } from './SectorOpening';

const TIME_AXIS_HEIGHT = 25;

interface ConfigurableAirspaceProps {
    currentTime: Date;
    monitoredPeriod: TimePeriod;
    monitoredTvs: Array<ExtendedMonitoredTv>;
    monitoredMeasures: Array<MonitoredMeasure>;
    monitoredMcdmMeasures: Array<MonitoredMcdmMeasure>;
    //selectedTvs: ExtendedMonitoredTv[]
    airspace: string;
    sectorOpenings: Array<AtcSectorOpening>;
    countType: CountType;
    tvsOccupancyPeriods?: { [key: string]: Map<FlightId, TimePeriod> };
    selectedPeriodByTv?: Map<string, Array<TimePeriod>>;
    onSelectedPeriodByTvChange?: (selectedPeriodByTv: Map<string, Array<TimePeriod>>) => void;
}

interface ConfigurableAirspaceState {
    folded: boolean;
}

export class ConfigurableAirspace extends PureComponent<ConfigurableAirspaceProps, ConfigurableAirspaceState> {
    state = {
        folded: false,
    };

    handleFoldedChange = (folded: boolean) => {
        this.setState({ folded: folded });
    };

    renderTimeAxis = () => {
        return (
            <AutoSizer>
                {({ height, width }) => {
                    const timeScale = TimeScale.newTimeScale(new Range(0, width), this.props.monitoredPeriod, null, 30);
                    return (
                        <TimeAxis
                            orientation={AxisOrientation.BOTTOM}
                            labelFormat={TimeLabelFormat.HH_MM}
                            timeScale={timeScale}
                            tickInterval={TimeAxis.chooseTickInterval(
                                timeScale,
                                15,
                                TimeLabelFormat.HH_MM,
                                AxisOrientation.BOTTOM,
                            )}
                            width={width}
                            height={TIME_AXIS_HEIGHT}
                            x={0}
                            y={height - TIME_AXIS_HEIGHT}
                            offsetForHorizontalLabelText={0}
                        />
                    );
                }}
            </AutoSizer>
        );
    };

    renderContent = () => {
        if (this.state.folded) return undefined;

        return (
            <>
                <Flex style={{ marginBottom: '1em' }}>
                    {this.props.sectorOpenings.map(sectorOpening => (
                        <SectorOpening
                            key={`sector-opening-${sectorOpening.configId}-${sectorOpening.timePeriod.from}`}
                            currentTime={this.props.currentTime}
                            monitoredPeriod={this.props.monitoredPeriod}
                            monitoredTvs={this.props.monitoredTvs}
                            monitoredMeasures={this.props.monitoredMeasures}
                            monitoredMcdmMeasures={this.props.monitoredMcdmMeasures}
                            sectorOpening={sectorOpening}
                            tvsOccupancyPeriods={this.props.tvsOccupancyPeriods}
                            selectedPeriodByTv={this.props.selectedPeriodByTv}
                            onSelectedPeriodByTvChange={this.props.onSelectedPeriodByTvChange}
                            countType={this.props.countType}
                        />
                    ))}
                </Flex>
                <Flex size={`${TIME_AXIS_HEIGHT}px`}>{this.renderTimeAxis()}</Flex>
            </>
        );
    };

    render() {
        /* size=0px sets flex to 1 1 0px, which evenly distributes space between each groupd-flow-section*/
        return (
            <Flex
                grow={!this.state.folded}
                shrink={this.state.folded}
                size="0px"
                direction="vertical"
                className="configurable-airspace">
                <div className="on-hover" style={{ position: 'relative' }}>
                    <FlowSectionHeader
                        title={this.props.airspace}
                        folded={this.state.folded}
                        onFoldedChange={this.handleFoldedChange}
                        nbTvs={0}
                        nbTvSets={0}
                    />
                </div>
                {this.renderContent()}
            </Flex>
        );
    }
}
